const EventEmitter = require('eventemitter3');
import getUnitState from '../../../isomorphic-helpers/getUnitState';
const BattleCalc = require('../../BattleCalc');
const Elf = require('../../../models/game_pieces/ai_units/summoned_units/Elf');
const SummonedCondition = require('../../conditions/SummonedCondition');
const { logError } = require('../../logger');
const DeathEvent = require('../../events/DeathEvent');
const { v4: uuidv4 } = require('uuid');

export default function SummonElf(battleState) {
  this.handle = 'summon_elf';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.tile && !victim.occupied;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      // kill elves on the board if above max
      const mySummoned = Object.values(battleState?.allUnits).filter(
        (unit) => unit.handle === 'elf' && unit.ownerId === actor.uid
      );
      const max_num_summoned = BattleCalc.getMaxNumSummons({
        ability_handle: ability.handle,
        caster_build: actor,
      });
      if (mySummoned.length + 1 >= max_num_summoned) {
        const num_to_kill = mySummoned.length + 1 - max_num_summoned;
        for (let i = 0; i < num_to_kill; ++i) {
          const random_index = Math.floor(Math.random() * mySummoned.length);
          const [summoned_to_kill] = mySummoned.splice(random_index, 1);
          new DeathEvent(battleState).execute(summoned_to_kill);
        }
      }

      const elf = Elf(ability.potency, actor);
      elf.ability_trees = elf.getAbilityTrees();
      elf.attributes = { base: elf.getBaseAttributes() };
      const elf_unit_state = getUnitState({ ai_unit: elf });
      elf_unit_state.uid = uuidv4();
      elf_unit_state.ownerId = actor.uid;
      elf_unit_state.x = victim.x;
      elf_unit_state.y = victim.y;

      for (const prop in elf_unit_state.equipment) {
        elf_unit_state.equipment[prop].tint = 0xd2f2b8; // 337433;
      }

      battleState.registerNewUnit(elf_unit_state);
      battleState.onUnitCondition(
        new SummonedCondition(actor, elf_unit_state, battleState, ability.duration)
      );

      const result = { elf: elf_unit_state };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'SummonElf',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
}
